import { useMutation, useQueryClient } from '@tanstack/react-query'
import { IMilkingProcessDeviationResponse } from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

type UpdateMilkingProcessDeviationFalseMarkParams = {
	id: number
	isFalse: boolean
}

export const useUpdateMilkingProcessDeviationFalseMark = () => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()

	return useMutation({
		mutationFn: ({
			id,
			isFalse,
		}: UpdateMilkingProcessDeviationFalseMarkParams) =>
			MilkingProcessService.updateMilkingProcessDeviationFalseMark(id, isFalse),
		onSuccess: updatedDeviation => {
			queryClient.setQueriesData<IMilkingProcessDeviationResponse>(
				{ queryKey: ['milking-process-deviation-list'] },
				oldData => {
					if (!oldData?.results) {
						return oldData
					}

					return {
						...oldData,
						results: oldData.results.map(deviation =>
							deviation.id === updatedDeviation.id
								? { ...deviation, ...updatedDeviation }
								: deviation,
						),
					}
				},
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Произошла ошибка',
					description: 'Не удалось обновить отклонение. Попробуйте снова.',
					isError: true,
				}),
			)
		},
	})
}
